import { BranchType } from "models/Branch";
import api from "Services/API";
import { ListResponseType } from "Services/Share.props";

export const getBranchesByVendorId = (vendorId: number) => {
    return api.get<ListResponseType<BranchType>>(
        `admin/branch?vendor_id=${vendorId}`
    );
};

export const restoreBranch = (id: number) => {
    return api.post(`admin/branch/${id}`);
};

export const deleteBranch = (id: number) => {
    return api.delete(`/admin/branch/${id}`);
};
